export default {
  OK: 200,
  SESSION_EXPIRED: 419
};
